import Axios from 'axios';

import { axios } from '@/plugins/axios';

let currentAbortController = null;

export async function calculateZonalDiscount(payload) {
    if (currentAbortController) {
        currentAbortController.abort();
    }

    currentAbortController = new AbortController();

    const { signal } = currentAbortController;

    try {
        const { data } = await axios.post('/zonal/calculate', payload, {
            signal
        });

        const discountAmount = data?.discountAmount || 0;
        const basketId = data?.basketId || null;

        return { discountAmount, basketId };
    } catch (error) {
        if (error.name !== 'AbortError' && !Axios.isCancel(error)) {
            throw error;
        }

        return { discountAmount: 0, basketId: null };
    } finally {
        currentAbortController = null;
    }
}
